"use strict";
define(
'stores/groups',[
	"jquery",
	"stores/store",
	"actions/groups",
	"constants/actiontypes"
],
function ($, StoreBase, Action, Constants)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);
		
		// Setup the instance
		this.groups = null;
		this.sectionCache = {};
		this.registerDispatchListener(function (action)
		{
			var self = this;
			switch(action.actionType) {
				case Constants.CREATED_GROUP:
					if (!this.groups)
						this.groups = {};

					if (Array.isArray(action.data)) {
						_.each(action.data, function(group) {
							self.addGroup(group);
						});
					}
					else {
						self.addGroup(action.data);
					}
					this.event.emit("change");
					break;
				case Constants.UPDATED_GROUP:
					var guid = action.id;
					for(var key in action.data) {
						self.groups[guid][key] = action.data[key];
					}
					this.event.emit("change");
					break;
				case Constants.DELETED_GROUP:
					if(this.groups[action.id]) {
						delete this.groups[action.id];
					}
					this.event.emit("change");
					break;
				case Constants.TRUNCATE_GROUP:
					this.groups = null;
					this.event.emit("change");
					break;
				case Constants.CLEAR_SECTION_CACHE:
					this.clearSectionCache(action.data.section_guid);
			}
		}.bind(this));

		this.action = new Action();
	}

	Store.prototype.addGroup = function (data)
	{
		this.groups[data.id.toLowerCase()] = data;
	}

	Store.prototype.get = function (id)
	{
		return this.groups[id];
	}

	Store.prototype.getAll = function ()
	{
		return _.map(this.groups, function(group) {
			return group;
		});
	}

	Store.prototype.hasGroup = function (id)
	{
		return (id.toLowerCase() in this.students);
	}

	Store.prototype.getGroup = function (id)
	{
		return this.groups[id.toLowerCase()];
	}

	Store.prototype.clearSectionCache = function(sectionId){
		delete this.sectionCache[sectionId]
	};

	Store.prototype.filterBySection = function (sectionId)
	{
		var ConnectToStores = require("shared/connect-to-stores");
		var section = ConnectToStores.classes.get(sectionId);

		var groups = {};

		if(section) {
			var ConnectToActions = require("shared/connect-to-actions");
			var sectionGroup = { data: {
				guid: sectionId,
				section_guid: sectionId,
				name: "All Students",
				created_at: null,
				updated_at: null,
				students: section.students
			}};
			
			groups[sectionId] = ConnectToActions.groups.initGroup(sectionGroup);
		}

		_.each(this.groups, function (item, index, list)
		{
			if (item.section_guid.toLowerCase() == sectionId.toLowerCase()) {
				groups[item.id] = item;
			}
		}, this);
		
		return groups;
	}

	return Store;
});
